export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11466.dbc14b0c.jpg";